module.exports = __webpack_public_path__ + "static/media/pinksapphero.897b4d8d.jpg";